var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _path2, _path3, _path4, _circle, _path5, _circle2, _path6, _circle3, _path7, _circle4, _path8, _circle5, _path9, _circle6, _path10, _circle7, _path11, _circle8, _path12, _circle9, _path13, _circle10, _path14, _path15, _path16, _path17, _path18, _path19, _rect20, _polygon, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _circle11, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _polygon2, _path43, _circle12, _path44;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllTrackweightloss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 335 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.43,43.32h13.7A16.1,16.1,0,0,0,107.21,41c8.12-6.89,14.16-8.68,17.64-9h0a11.48,11.48,0,0,1,2.66,0h3.93c2.27-.29,9.43-.21,20.31,9l2.14,2.19a10.17,10.17,0,0,0,15.74-1.46l5.53-8.3a11.82,11.82,0,0,1,18.11-1.87l6.15,6a34.9,34.9,0,0,0,9.23,6.51l4.14,2a24.82,24.82,0,0,0,22,.15,21.37,21.37,0,0,1,18.91-.17l11.1,5.35,5.45,2.66C280.07,59,306.9,65.2,317.87,65.2V87.91H79.43Z",
    fill: "#aad4ff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58.43,
    y: 9.82,
    width: 259.47,
    height: 1,
    fill: "#aad4ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 79.43,
    y: 19.82,
    width: 238.47,
    height: 1,
    fill: "#aad4ff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 89.43,
    y: 29.82,
    width: 228.47,
    height: 1,
    fill: "#aad4ff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 89.43,
    y: 39.82,
    width: 228.47,
    height: 1,
    fill: "#aad4ff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 89.43,
    y: 49.82,
    width: 228.47,
    height: 1,
    fill: "#aad4ff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 89.43,
    y: 59.82,
    width: 228.47,
    height: 1,
    fill: "#aad4ff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 79.43,
    y: 69.82,
    width: 238.47,
    height: 1,
    fill: "#aad4ff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 79.43,
    y: 79.82,
    width: 238.47,
    height: 1,
    fill: "#aad4ff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 280.52,
    y: 72.45,
    width: 9.35,
    height: 15.46,
    transform: "translate(570.39 160.36) rotate(-180)",
    fill: "#007fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 300.52,
    y: 78.45,
    width: 9.35,
    height: 9.46,
    transform: "translate(610.39 166.36) rotate(-180)",
    fill: "#007fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 260.1,
    y: 62.45,
    width: 9.35,
    height: 25.46,
    transform: "translate(529.55 150.36) rotate(-180)",
    fill: "#007fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 239.68,
    y: 52.45,
    width: 9.35,
    height: 35.46,
    transform: "translate(488.71 140.36) rotate(-180)",
    fill: "#007fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 62.45,
    width: 9.35,
    height: 25.46,
    transform: "translate(325.34 150.36) rotate(-180)",
    fill: "#007fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 219.26,
    y: 62.45,
    width: 9.35,
    height: 25.46,
    transform: "translate(447.87 150.36) rotate(-180)",
    fill: "#007fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 178.42,
    y: 39.45,
    width: 9.35,
    height: 48.46,
    transform: "translate(366.18 127.36) rotate(-180)",
    fill: "#007fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 138.42,
    y: 42.45,
    width: 9.35,
    height: 45.46,
    transform: "translate(286.18 130.36) rotate(-180)",
    fill: "#007fff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 198.84,
    y: 52.45,
    width: 9.35,
    height: 35.46,
    transform: "translate(407.02 140.36) rotate(-180)",
    fill: "#007fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 118.84,
    y: 46.45,
    width: 9.35,
    height: 41.46,
    fill: "#007fff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 98.42,
    y: 52.45,
    width: 9.35,
    height: 35.46,
    fill: "#007fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14,88.91H326.86a1,1,0,0,0,0-2H8.14a1,1,0,0,0,0,2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M317.87,65.2c-11.13,0-38.1-6.25-48.09-11.15l-5.45-2.66L253.23,46a20.24,20.24,0,0,0-17.74,0,26.36,26.36,0,0,1-23.12,0l-4.15-2a36.23,36.23,0,0,1-9.49-6.69l-6.15-6.05A10.82,10.82,0,0,0,176,33l-5.53,8.3a11.17,11.17,0,0,1-17.28,1.6l-2.14-2.19a28.62,28.62,0,0,0-20.37-8.59,1,1,0,0,1,0-2,30.65,30.65,0,0,1,21.8,9.19l2.14,2.19a9.17,9.17,0,0,0,14.19-1.31l5.53-8.3a12.81,12.81,0,0,1,19.64-2l6.15,6a34.05,34.05,0,0,0,9,6.32l4.16,2a24.3,24.3,0,0,0,21.37,0,22.21,22.21,0,0,1,19.48,0l16.56,8c9.81,4.8,36.29,10.94,47.21,10.94a1,1,0,0,1,0,2Z",
    fill: "#007fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.09,44.32H89.43a1,1,0,0,1,0-2h13.32l3.88-3c4.27-4.32,13.73-7.19,19-8.52a20.73,20.73,0,0,1,5.05-.62,1,1,0,0,1,0,2,18.67,18.67,0,0,0-4.56.56c-4.09,1-14.06,3.88-18.1,8l-.1.09-4.21,3.28A1,1,0,0,1,103.09,44.32Z",
    fill: "#007fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 285.19,
    cy: 58.33,
    r: 3.83,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M285.19,63.15A4.83,4.83,0,1,1,290,58.33,4.82,4.82,0,0,1,285.19,63.15Zm0-7.65A2.83,2.83,0,1,0,288,58.33,2.83,2.83,0,0,0,285.19,55.5Z",
    fill: "#007fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 244.59,
    cy: 42.45,
    r: 3.83,
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M244.59,47.28a4.83,4.83,0,1,1,4.83-4.83A4.82,4.82,0,0,1,244.59,47.28Zm0-7.65a2.83,2.83,0,1,0,2.83,2.82A2.82,2.82,0,0,0,244.59,39.63Z",
    fill: "#007fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.29,
    cy: 48.15,
    r: 3.83,
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M224.29,53a4.83,4.83,0,1,1,4.83-4.83A4.82,4.82,0,0,1,224.29,53Zm0-7.65a2.83,2.83,0,1,0,2.83,2.82A2.82,2.82,0,0,0,224.29,45.33Z",
    fill: "#007fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.99,
    cy: 40.88,
    r: 3.83,
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M204,45.71a4.83,4.83,0,1,1,4.83-4.83A4.83,4.83,0,0,1,204,45.71Zm0-7.65a2.83,2.83,0,1,0,2.83,2.82A2.82,2.82,0,0,0,204,38.06Z",
    fill: "#007fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.69,
    cy: 27.48,
    r: 3.83,
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M183.69,32.3a4.83,4.83,0,1,1,4.83-4.82A4.82,4.82,0,0,1,183.69,32.3Zm0-7.65a2.83,2.83,0,1,0,2.83,2.83A2.83,2.83,0,0,0,183.69,24.65Z",
    fill: "#007fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.39,
    cy: 44.71,
    r: 3.83,
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M163.39,49.54a4.83,4.83,0,1,1,4.83-4.83A4.84,4.84,0,0,1,163.39,49.54Zm0-7.66a2.83,2.83,0,1,0,2.83,2.83A2.83,2.83,0,0,0,163.39,41.88Z",
    fill: "#007fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.09,
    cy: 34.32,
    r: 3.83,
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M143.09,39.15a4.83,4.83,0,1,1,4.83-4.83A4.84,4.84,0,0,1,143.09,39.15Zm0-7.65a2.83,2.83,0,1,0,2.83,2.82A2.83,2.83,0,0,0,143.09,31.5Z",
    fill: "#007fff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.51,
    cy: 32.32,
    r: 3.83,
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.51,37.15a4.83,4.83,0,1,1,4.83-4.83A4.83,4.83,0,0,1,123.51,37.15Zm0-7.65a2.83,2.83,0,1,0,2.83,2.82A2.82,2.82,0,0,0,123.51,29.5Z",
    fill: "#007fff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.09,
    cy: 43.32,
    r: 3.83,
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M103.09,48.15a4.83,4.83,0,1,1,4.83-4.83A4.84,4.84,0,0,1,103.09,48.15Zm0-7.65a2.83,2.83,0,1,0,2.83,2.82A2.83,2.83,0,0,0,103.09,40.5Z",
    fill: "#007fff"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.89,
    cy: 50.6,
    r: 3.83,
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M264.89,55.42a4.83,4.83,0,1,1,4.83-4.82A4.82,4.82,0,0,1,264.89,55.42Zm0-7.65a2.83,2.83,0,1,0,2.83,2.83A2.83,2.83,0,0,0,264.89,47.77Z",
    fill: "#007fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84,91H26.55L17.28,27.4h0a88.23,88.23,0,0,1,76,0h0Z",
    fill: "#e6e6e6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55.28,18.8a88.15,88.15,0,0,1,38,8.6h0L84,91H26.55L17.28,27.4h0a88.12,88.12,0,0,1,38-8.6m0-2a90.6,90.6,0,0,0-38.87,8.8,2,2,0,0,0-1.11,2.09l9.27,63.64a2,2,0,0,0,2,1.71H84a2,2,0,0,0,2-1.71l9.27-63.64a2,2,0,0,0-1.12-2.09,90.53,90.53,0,0,0-38.86-8.8Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31,83.25,23.68,32.77a2.71,2.71,0,0,1,1.69-2.91,82.51,82.51,0,0,1,59.81,0,2.72,2.72,0,0,1,1.7,2.91L79.53,83.25a2.77,2.77,0,0,1-2.76,2.34h-43A2.76,2.76,0,0,1,31,83.25Z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.28,24.25a83.06,83.06,0,0,1,29.9,5.61,2.72,2.72,0,0,1,1.7,2.91L79.53,83.25a2.77,2.77,0,0,1-2.76,2.34h-43A2.76,2.76,0,0,1,31,83.25L23.68,32.77a2.71,2.71,0,0,1,1.69-2.91,83.11,83.11,0,0,1,29.91-5.61m0-1A84.62,84.62,0,0,0,25,28.93a3.69,3.69,0,0,0-2.32,4L30,83.39a3.78,3.78,0,0,0,3.74,3.2h43a3.8,3.8,0,0,0,3.75-3.2l7.35-50.47a3.69,3.69,0,0,0-2.33-4,84.56,84.56,0,0,0-30.26-5.68Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M72.61,33.38v7.39H37.94V33.38H72.61m0-2H37.94a2,2,0,0,0-2,2v7.39a2,2,0,0,0,2,2H72.61a2,2,0,0,0,2-2V33.38a2,2,0,0,0-2-2Z"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 37.94,
    y: 33.38,
    width: 34.67,
    height: 7.39,
    fill: "#176fa5"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "72.61 40.77 37.94 40.77 72.61 33.38 72.61 40.77",
    fill: "#015f9b"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M55.28,81.7a1,1,0,0,1-1-1v-8a1,1,0,0,1,2,0v8A1,1,0,0,1,55.28,81.7Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M55.28,63.39a1,1,0,0,1-1-1V49.58a1,1,0,0,1,2,0V62.39A1,1,0,0,1,55.28,63.39Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M33.74,47.68H30.12a1,1,0,1,1,0-2h3.62a1,1,0,0,1,0,2Z",
    fill: "#e6e6e6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M40.23,54.54h-9a1,1,0,1,1,0-2h9a1,1,0,0,1,0,2Z",
    fill: "#e6e6e6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5,61.4H32.4a1,1,0,0,1,0-2H49.5a1,1,0,0,1,0,2Z",
    fill: "#e6e6e6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5,68.26h-16a1,1,0,0,1,0-2h16a1,1,0,0,1,0,2Z",
    fill: "#e6e6e6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5,75.12H34.68a1,1,0,0,1,0-2H49.5a1,1,0,0,1,0,2Z",
    fill: "#e6e6e6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5,82H35.82a1,1,0,0,1,0-2H49.5a1,1,0,1,1,0,2Z",
    fill: "#e6e6e6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M80,47.68H76.39a1,1,0,0,1,0-2H80a1,1,0,0,1,0,2Z",
    fill: "#e6e6e6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M78.88,54.54h-9a1,1,0,0,1,0-2h9a1,1,0,0,1,0,2Z",
    fill: "#e6e6e6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M77.74,61.4H60.64a1,1,0,0,1,0-2h17.1a1,1,0,0,1,0,2Z",
    fill: "#e6e6e6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6,68.26h-16a1,1,0,0,1,0-2h16a1,1,0,0,1,0,2Z",
    fill: "#e6e6e6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M75.45,75.12H60.64a1,1,0,1,1,0-2H75.45a1,1,0,0,1,0,2Z",
    fill: "#e6e6e6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M74.31,82H60.64a1,1,0,0,1,0-2H74.31a1,1,0,0,1,0,2Z",
    fill: "#e6e6e6"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.28,
    cy: 31.96,
    r: 21,
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M74,32a18.59,18.59,0,0,1-2.12,8.64l-6.32-3.69a11.32,11.32,0,0,0,0-9.9l6.32-3.7A18.66,18.66,0,0,1,74,32Z",
    fill: "#e6e6e6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M71,21.73l-6.32,3.7a11.38,11.38,0,0,0-8.44-4.84V13.27A18.67,18.67,0,0,1,71,21.73Z",
    fill: "#e6e6e6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M43.87,32A11.42,11.42,0,0,0,45,36.91L38.68,40.6a18.69,18.69,0,0,1,0-17.29L45,27A11.39,11.39,0,0,0,43.87,32Z",
    fill: "#e6e6e6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M54.36,13.27v7.32a11.38,11.38,0,0,0-8.43,4.84l-6.33-3.7A18.69,18.69,0,0,1,54.36,13.27Z",
    fill: "#e6e6e6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M55.26,11a21,21,0,1,1-10.6,2.88A21,21,0,0,1,55.26,11m0-2V9h0A23,23,0,1,0,75.12,20.33,23,23,0,0,0,55.26,9Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M61,47.11H49.59a1,1,0,0,1,0-2H61a1,1,0,0,1,0,2Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3,38.7a6.74,6.74,0,0,1-2.73-12.92l2.66-4.52,2.71,4.5A6.74,6.74,0,0,1,55.3,38.7Z",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M62,32a6.75,6.75,0,1,1-13.49-.06h0Z",
    fill: "#e6e6e6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M55.24,21.26l2.7,4.49h0A6.74,6.74,0,0,1,62,31.93a6.64,6.64,0,0,1-.92,3.41,6.72,6.72,0,0,1-5.8,3.37h0a6.75,6.75,0,0,1-5.84-10.13h0a6.87,6.87,0,0,1,3.13-2.8l2.67-4.51m0-2h0a2,2,0,0,0-1.71,1l-2.36,4a8.76,8.76,0,1,0,8.19,0l-2.4-4a2,2,0,0,0-1.71-1Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "54.1 25.59 55.24 23.27 56.41 25.58 54.1 25.59",
    fill: "#007fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M55.28,29.22a2.74,2.74,0,0,1,0,5.48h0a2.74,2.74,0,0,1,0-5.48h0m0-2h0A4.73,4.73,0,1,0,60,31.94a4.74,4.74,0,0,0-4.76-4.72Z"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.28,
    cy: 31.96,
    r: 1.88,
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M55.28,11a21,21,0,0,1,.08,42h-.08a21,21,0,0,1-.09-42h.09m0-2h-.09a23,23,0,0,0,.09,46h.09a23,23,0,0,0-.09-46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllTrackweightloss);
export default __webpack_public_path__ + "static/media/ill_trackweightloss.b2378dd68e1908c33756dee2571de97d.svg";
export { ForwardRef as ReactComponent };